const getters = {
  token: state => state.user.token,
  cakeGoodsList: state => state.cakeGoods.cakeGoodsList
}

export default getters